import {inject} from 'aurelia-framework';
import * as _ from 'lodash';
import {Client} from '../../api/client';
import {I18N} from 'aurelia-i18n';

@inject(Client,I18N)
export class ConfigurationLoader
{
    constructor(client, i18n)
    {
        this.client = client;
        this.i18n = i18n;
    }

    get(config, viewContext)
    {
        if (_.isString(config)) {

            let queryParams = '?_locale='+this.i18n.getLocale();
            if (viewContext) {
                queryParams += '&viewContext=' + viewContext;
            }

            return this.client.get(config + '/list' + queryParams, 60);

        } else if (_.isObject(config)) {
            return Promise.resolve(config);
        } else {
            return Promise.reject(new Error(`Invalid configuration "${config}".`));
        }
    }
}
